export default function create(options) {
  const {
    opacity = 0,
    range = 'in'
  } = options.namedEffect;
  const fromValue = range === 'out' ? 'var(--comp-opacity, 1)' : opacity;
  const toValue = range === 'out' ? opacity : 'var(--comp-opacity, 1)';
  const easing = 'linear';
  return [{
    ...options,
    easing,
    keyframes: [{
      opacity: fromValue
    }, {
      opacity: toValue
    }]
  }];
  /*
   * @keyframes <name> {
   *   from {
   *     opacity: <fromValue>;
   *   }
   *   to {
   *     opacity: <toValue>;
   *   }
   * }
   */
}
//# sourceMappingURL=FadeScroll.js.map